export default "__VITE_ASSET__$D6Ox0wo__"